module.exports = __webpack_public_path__ + "img/312.ae312043.jpg";